<!--
    作者：caoshixian
    时间：2020-10-21
    描述：分享记录
 -->
<template>
  <div v-loading="loading">
    <el-form :inline="true" class="share_records">
      <el-form-item label="用户名称">
        <el-input placeholder="请输入用户名称" v-model="userName"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select placeholder="请选择分享的类型" v-model="type">
          <el-option label="全部" value="all"></el-option>
          <el-option label="文章" value="article"></el-option>
          <el-option label="产品" value="product"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryShareRecord">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" stripe style="width: 100%" border>
      <el-table-column
        align="center"
        prop="sharer_id"
        label="分享者id"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="sharer_avatarUrl"
        label="分享者头像"
      >
      <template slot-scope="scope">
        <el-image style="width:60px" :src="scope.row.sharer_avatarUrl"></el-image>
      </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sharer_name"
        label="分享者名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="reader_id"
        label="阅读者id"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="reader_name"
        label="阅读者名称"
      >
      </el-table-column>
      <el-table-column align="center" prop="goods_title" label="标题" width="100">
      </el-table-column>
      <el-table-column align="center" prop="goods_type" label="类型" width="100">
      </el-table-column>
      <el-table-column
        align="center"
        prop="promoter_id"
        label="直推者id"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="promoter_money"
        label="直推奖励"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="interlocutor_id"
        label="间推者id"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="interlocutor_money"
        label="间推奖励"
      >
      </el-table-column>
      <el-table-column prop="create_time" label="浏览时间"> </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import ShareApi from "@/api/sharepolite.js";
import { setCookie, setSessionStorage } from "@/utils/base.js";

export default {
  data() {
    return {
      loading: true,
      type: "all",
      userName: "",
      /*一页多少条*/
      pageSize: 1,
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,

      tableData: [],
    };
  },
  created() {
    this.getsharerecords('','all');
  },
  methods: {
    // 获取分享记录
    getsharerecords(username='',type='all') {
      // let params = { page: this.curPage };
      let params = {usrname:username,type:type,page: this.curPage}
      ShareApi.queryShareRecord(params, false).then((res) => {
        
        this.tableData = res.data.data.data;
        this.loading = false;
       
        this.total = res.data.data.total;
        this.pageSize = res.data.data.per_page;
      });
    },
    // 查询分享记录
    queryShareRecord() {
      this.loading = true;
      let params = { username: this.$data.userName, type: this.$data.type };

      ShareApi.queryShareRecord(params, true).then((res) => {
        console.log(res)
        this.loading = false;
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.pageSize = res.data.data.per_page;
      });
    },
    // handleClick(e) {
    //   console.log(e.name);
    // },
    // changePageSize(e) {
    //   let params = { pageSize: e };
    //   ShareApi.sharerecords(params, true).then((res) => {
    //     console.log(res.data.data.data);
    //     return false;
    //     this.tableData = res.data.data[0];
    //     this.loading = false;
    //     this.curPage = res.data[0].current_page;
    //     this.total = res.data[0].total;
    //     this.pageSize = res.data[0].per_page;
    //   });
    // },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getsharerecords();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getsharerecords();
    },
  },
};
</script>

<style lang="scss" scoped>
.paginate {
  margin-top: 4em;
}
</style>



// WEBPACK FOOTER //
// src/components/sharepolite/sharepolite.vue